import angular, {
  IAttributes,
  ICompileService,
  IDirective,
  IScope,
  ITemplateLinkingFunction,
} from "angular";
import {
  ContractService,
  vsServiceName as ContractServiceName,
  IContractType,
} from "../../../shared/ContractService";
import { kebabCase } from "lodash";

export const vsDirectiveName = "contractDetail";

const typeAttributeName = "type";
const contractAttributeName = "contract";

const linkingFunctions: { [name: string]: ITemplateLinkingFunction } = {};

contractDetailDirectiveFactory.$inject = [ContractServiceName, "$compile"];
export function contractDetailDirectiveFactory(
  contractService: ContractService,
  $compile: ICompileService
): IDirective {
  let currentTransclusionScope: IScope | undefined = undefined;
  let currentTranscludedContent: JQLite | undefined = undefined;

  return {
    link: {
      pre: (s, element, attrs, ctrl, transclude) => {
        attrs.$observe(typeAttributeName, (value?: string) => {
          if (!value) {
            destroyTransclusion();
            return;
          }
        });

        const contractType = contractService.getContractType(
          attrs[typeAttributeName]
        );

        if (!contractType) {
          throw new Error("Couldn't match type");
        }

        const linkingFunction = getLinkingFunction(contractType, attrs);

        const detailElementInstance = linkingFunction(
          s.$new(),
          (clone, scope) => {
            currentTransclusionScope?.$destroy();
            currentTranscludedContent?.remove();

            currentTransclusionScope = scope;
            currentTranscludedContent = clone;
          }
        );
        element.append(detailElementInstance);
      },
    },
  };

  function destroyTransclusion() {
    currentTranscludedContent?.remove();
    currentTransclusionScope?.$destroy();
  }

  function getLinkingFunction(contractType: IContractType, attrs: IAttributes) {
    if (Object.keys(linkingFunctions).find((n) => n === contractType.id)) {
      return linkingFunctions[contractType.id];
    }

    const kebabComponentName = kebabCase(contractType.detailComponentName);

    const detailElement = angular.element(
      `<${kebabComponentName}></${kebabComponentName}>`
    );

    detailElement.attr(contractAttributeName, attrs[contractAttributeName]);
    detailElement.attr(typeAttributeName, attrs[typeAttributeName]);

    return (linkingFunctions[contractType.id] = $compile(detailElement));
  }
}
